import {popModal} from './login-modal';
import {dropMemberMenu} from './member-dropdown';
import {getClosest} from './globals';
var ng_nav = ng_nav || {};

/*
 * moveElements
 * Move Panel Navigation & Cover Elements to before body
 *
 * Deprecated
*/
ng_nav.moveElements = (div) => {
	div.forEach(function(name) { 
		var panelNavElement = document.getElementById(name);
		document.body.appendChild(panelNavElement);
	});
};
let panelElements = ['panel-nav', 'panel-nav-cover'];
//ng_nav.moveElements(panelElements);


var exitButton = document.getElementById('menu-exit-toggle');

// Assign Constants
const ng_consts = {
  mainNav: document.getElementById('primary-navigation'),
  utilNav: document.getElementById('utility-navigation'),
  searchWrap: document.querySelector('.search-wrap'),
  searchWrapMobile: document.querySelector('.search-mobile-wrap'),
  panelNav: document.getElementById('panel-nav'),
  panelNavCover: document.getElementById('panel-nav-cover'),
  toggleButton: document.getElementById('mobile-toggle-menu'),
  mobileSubMenu: document.getElementsByClassName('submenu')
};
let searchBoxDesktop = ng_consts.searchWrap.querySelector('input.form-control');
searchBoxDesktop.setAttribute('placeholder', 'Search');
let searchBoxMobile = ng_consts.searchWrapMobile.querySelector('input.form-control');
searchBoxMobile.setAttribute('placeholder', 'Search');


let ng_clones = {};

/* MOBILE NAV CREATION WORKFLOW */

ng_nav.setUpMobile = () => {
  let cloneMenus = new Promise((resolve) => {
    
    /*
    * cloneMenus
    * Clone menus into mobile nav
    */

    // Clone Main Nav
    ng_clones.mainNavClone = ng_consts.mainNav.cloneNode(true);
    ng_clones.mainNavClone.removeAttribute('id'); // Reset ID
    ng_clones.menuWrap = document.createElement('DIV'); // Create wrapper
    ng_clones.menuWrap.classList.add('primary-mobile-wrap'); //add unique class
    ng_clones.menuWrap.appendChild(ng_clones.mainNavClone);
    ng_consts.panelNav.appendChild(ng_clones.menuWrap);

    // Clone Utility Nav
    ng_clones.utilNavClone = ng_consts.utilNav.cloneNode(true);
    ng_clones.utilNavClone.removeAttribute('id'); // Reset ID
    ng_clones.menuUtilWrap = document.createElement('DIV'); // Create wrapper
    ng_clones.menuUtilWrap.classList.add('utility-mobile-wrap'); //add unique class
    ng_clones.menuUtilWrap.appendChild(ng_clones.utilNavClone);
    ng_consts.panelNav.appendChild(ng_clones.menuUtilWrap);

    //add overflow hidden to mobile L2
    for (var e=0; e < ng_consts.mobileSubMenu.length; e++) {
      ng_consts.mobileSubMenu[e].style.overflow = "hidden";
    }

    resolve(cloneMenus);

  });

  cloneMenus.then(function() {

    //change member login ID to be unique; if exists (i.e. if not logged in)
    if (ng_consts.panelNav.querySelector('#member-login-button') != null || ng_consts.panelNav.querySelector('#member-login-button') != undefined) {
      ng_consts.panelNav.querySelector('#member-login-button').id = "mobile-member-login-button";
    }
    //ditto to logged in member button
    if (ng_consts.panelNav.querySelector('#logged-in-toggle') != null || ng_consts.panelNav.querySelector('#logged-in-toggle') != undefined) {
      ng_consts.panelNav.querySelector('#logged-in-toggle').id = "mobile-logged-in-toggle";
      //further controls in /components/member-dropdown.js
    }

    // init new vars
    let navItemHasChildren = document.getElementsByClassName('has-children');
    let mobileItemHasChildren = [];
    let mobileDropButtons;

    //isolate mobile only
    for (var t=0; t < navItemHasChildren.length; t++) {
      if (navItemHasChildren[t].parentElement.parentElement.parentElement.classList.contains("primary-mobile-wrap")) {
        mobileItemHasChildren.push(navItemHasChildren[t])
      }
    }
    /*
    * addButtons
    * Add dropdown buttons to menu items with children
    *
    */
    ng_nav.addButtons = () => {

      for (var a=0; a < mobileItemHasChildren.length; a++) {
        //create buttons
        let dropButton = document.createElement('button');
        dropButton.classList.add("mobile-dropdown-button");
        dropButton.classList.add("button");
        dropButton.classList.add("light");
        dropButton.setAttribute("aria-expanded", "false");

        var buttonImg = document.createElement('img');
        buttonImg.setAttribute('alt', 'Toggle Second Level of Menu');
        buttonImg.setAttribute('src', '/NationalGuild/assets/arrow-down.png');
        dropButton.appendChild(buttonImg);

        //append to menu
        mobileItemHasChildren[a].appendChild(dropButton);
      }

      //add to button array
      mobileDropButtons = document.getElementsByClassName('mobile-dropdown-button');

    }

    /*
    * mobileDrop
    * Toggle mobile menu 2nd level dropdowns
    *
    */
    
    ng_nav.hereStateSetup = function() {
      let menuToOpen = document.querySelector('.primary-mobile-wrap .submenu li.current');
      if (menuToOpen != null && menuToOpen) {
        let button = menuToOpen.parentNode.nextElementSibling;
        menuToOpen.parentNode.classList.add('open');
        menuToOpen.parentNode.style.overflow = "auto";
        button.setAttribute('aria-expanded', true);
      }

    }

    ng_nav.mobileDrop = function(e) {
      e.preventDefault()
      let button = this;
      let mobileItemParent = this.parentElement;
      let mobileItemChildren = mobileItemParent.children;
      for (var i=0; i < mobileItemChildren.length; i++) {
        if (mobileItemChildren[i].classList.contains("submenu")) {
          let mobileL2List = mobileItemChildren[i];
          if (mobileL2List.classList.contains('open')) {
            mobileL2List.classList.remove('open');
            button.setAttribute('aria-expanded', false);
          } else {
            setTimeout(function() {
              mobileL2List.classList.add('open');
            }, 400);
            button.setAttribute('aria-expanded', true);
          }


        }
      }
    }

    /*
    * toggleMenu
    * Toggle mobile menu function
    *
    */
    ng_nav.toggleMenu = () =>{
      if(document.body.classList.contains('panel-active')){
        document.body.classList.remove("panel-active");
         ng_consts.toggleButton.setAttribute('aria-expanded', 'false');
      }else{
        document.body.classList.add("panel-active");
         ng_consts.toggleButton.setAttribute('aria-expanded', 'true');
      }
    }

    //run 
    ng_consts.toggleButton.addEventListener('click', function() {
    })
    ng_nav.addButtons();
    ng_nav.hereStateSetup();
    for (var l=0; l < mobileDropButtons.length; l++) {
      mobileDropButtons[l].addEventListener('click', ng_nav.mobileDrop);
    }
    ng_consts.panelNavCover.addEventListener('click', ng_nav.toggleMenu);
    ng_consts.toggleButton.addEventListener('click', ng_nav.toggleMenu);
    exitButton.addEventListener('click', ng_nav.toggleMenu);
    //mobile login
    if (document.getElementById('mobile-member-login-button') != undefined || document.getElementById('mobile-member-login-button') != null) {
      let mobileLoginButton = document.getElementById('mobile-member-login-button');
      mobileLoginButton.addEventListener('click', popModal);
    }
    //mobile logged in menu
    if (document.getElementById('mobile-logged-in-toggle') != undefined || document.getElementById('mobile-logged-in-toggle') != null) {
      let toggleMobile = document.getElementById('mobile-logged-in-toggle');
      toggleMobile.addEventListener('click', dropMemberMenu);
      //add overflow hidden to mobile member dropdown
      let topMemberMenu = getClosest(toggleMobile, '.logged-in-menu-top');
      let memberMenu = topMemberMenu.querySelector('.logged-in-menu');
      memberMenu.style.overflow = "hidden";
    }
  });

}

ng_nav.setUpMobile();

export function closeMenu() {
  if(document.body.classList.contains('panel-active')){
    document.body.classList.remove("panel-active");
    ng_consts.toggleButton.setAttribute('aria-expanded', 'false');
  }
}






// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/mobile-menu.js